import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedIncomeOfferSellEntityNormalized } from '../../../../../../../../../store/product/types';

import { FixedIncomeListItemDesktop } from './desktop';
import { FixedIncomeListItemMobile } from './mobile';
import { FixedIncomeListItemTablet } from './tablet';

export namespace FixedIncomeListItemTypes {
  export interface Props {
    offer: FixedIncomeOfferSellEntityNormalized;
  }
}

export const FixedIncomeListItem: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const fixedIncomeListItem = useBreakpointValue({
    base: <FixedIncomeListItemMobile offer={offer} />,
    sm: <FixedIncomeListItemTablet offer={offer} />,
    lg: <FixedIncomeListItemDesktop offer={offer} />,
  });

  return fixedIncomeListItem;
};
